export default "/img/AR.35225c26c2d7bd51dc617630b114de95.png";